// ABOUTME: The frame every Production Scheduling page renders inside.
// ABOUTME: SparkApplicationLayout decides what that frame is, including when the chrome fails to load.

import React from "react";
import SparkApplicationLayout from "./spark/SparkApplicationLayout";

export default function ApplicationLayout({ children }) {
  return <SparkApplicationLayout>{children}</SparkApplicationLayout>;
}
